import React, {CSSProperties, Dispatch, SetStateAction} from 'react';
import {useMoralis} from "react-moralis";
import 'react-toastify/dist/ReactToastify.css';
import uniqid from 'uniqid';
import MoralisType from "moralis";
import {API} from "aws-amplify";
import {IApiArgosId, IUser} from "../types/type";
import argos from '../assets/argos.svg';
import {toastError} from "../toast";
import {useTranslation} from "react-i18next";
import SmallLoading from "../components/SmallLoading";



interface ISignIn {
    setUser: Dispatch<SetStateAction<IUser>>
    setAlreadyUserId: Dispatch<SetStateAction<boolean>>
    setFirstVisit: Dispatch<SetStateAction<boolean>>
    buttonStyle : string | object
    env : "dev" | "live"
}


const SignIn: React.FC<ISignIn> = ({setUser, setAlreadyUserId, setFirstVisit, buttonStyle,env}) => {

    const {
        authenticate,
        isWeb3EnableLoading
    } = useMoralis();

    const {t} = useTranslation();



    const login = async () : Promise<unknown> => {
        try {


            if (isWeb3EnableLoading) return;

            const clientId : string = env === 'live'
                ?
                'BG9NUPNMcaInvbmYtLQ6iUHlu0H0ZSsLcO-PK7uY7BkLXNse6rrobIT5wvhKwVU6R9Yki6Nb15t65T8XNflgbew'
                :
                "BNTL8XTfOqDB-rG8mbJ4vqEbRWA8qIcT4e26jQHQkTbMOVcF0TaR5Fzqk5921mspB_xZSbOmb7iEpEvzxawoFuA"


            const user: MoralisType.User | undefined = await authenticate({
                provider: "web3Auth",
                clientId: clientId,
                theme: 'light',
                loginMethodsOrder: ["google", "twitter", "linkedin", 'kakao', 'line'],
                appLogo : argos,
                onSuccess : (user) => console.log('User Login :::',user),
                onError : (error) => {
                    if (!error.message.includes('Web3Auth: User closed login modal')) {
                        return login()
                    }
                }
            })


            if (user) {
                const {id: objId} = user

                const apiPath = `/user?alias=${env}&requestType=getObject&objectId=${objId}`
                const data: IApiArgosId = await API.get('apiArgosID', apiPath, {});
                if (data.userId) {
                    setAlreadyUserId(true);
                    setUser(prev => ({
                        ...prev,
                        objectId: objId,
                        id: data.userId as string
                    }))
                } else {
                    const userId = uniqid();
                    const setUserPath = `/user?alias=${env}&requestType=setUserId&userId=${userId}&objectId=${objId}`
                    await API.get('apiArgosID', setUserPath, {});
                    setUser(prev => ({
                        ...prev,
                        objectId: objId,
                        id: userId
                    }))
                    setFirstVisit(true)
                }
            }

        } catch (e) {
            return toastError(t('something-is-wrong'));
        }
    }


    return (
        <div>
            <button type="button"
                    style={buttonStyle as CSSProperties ?? {}}
                    onClick={login}
                    className="argos-id-button">
                <img src={argos} alt={'argos-id'} className={'mr-1'} style={{'width': '15px', 'height': '15px' , 'marginRight' : '7px'}}/>
                {t("connect-user")}
                {isWeb3EnableLoading && <SmallLoading borderRightColor={'deepskyblue'} />}
            </button>
        </div>

    );

}

export default SignIn